/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import ShareCardModel from '../../../../models/ShareCardModel';

import RegisteredJewelry from '../components/RegisteredJewelry';
import RegisterNewJewelry from '../components/RegisterNewJewelry';

interface Props {
  shareCardColorModel: any;
  shareCardId: any;
  shareCard: ShareCardModel;
  languageCode: string;
}

const ShareCardSummaryMedicalJewelry = (props: Props) => {
  const { shareCardColorModel, shareCardId, shareCard, languageCode } = props;
  const shareCardColor = shareCardColorModel.darkAccentColor();
  const jewelryCollection = shareCard.jewelry.collection();

  if (!shareCard.jewelry.isAllowed()) { return null; }

  return (
    <div className="cmp-sharecardsummary-group">
      <div className="cmp-sharecardsummary-medicaljewelry">

        {
          jewelryCollection.length > 0 && (
            <div className="font-footnote">
              <FormattedMessage id="shareCard.medicalJewelry.title.label" />
            </div>
          )
        }

        {
          jewelryCollection.map((j, i) => (
            <div style={{ marginBottom: 18 }} key={i}>
              <RegisteredJewelry
                data={j}
                shareCardColorModel={shareCardColorModel}
              />
            </div>
          ))
        }
        <RegisterNewJewelry
          color={shareCardColor}
          shareCardId={shareCardId}
          languageCode={languageCode}
          noExistingJewelry={!jewelryCollection.length}
        />
      </div>
    </div>
  );
};

export default ShareCardSummaryMedicalJewelry;
